<template>
  <nav id="menu" class="menu-block">
    <div class="menu-block-wrapper">
      <ul>
        <li><router-link :to="{ path: '/work' }" data-cursor-hover data-cursor-mix-blend-mode="difference">Work</router-link></li>
        <li><router-link :to="{ path: '/about' }" data-cursor-hover data-cursor-mix-blend-mode="difference">About</router-link></li>
        <li><router-link :to="{ path: '/services' }" data-cursor-hover data-cursor-mix-blend-mode="difference">Services</router-link></li>
        <li><router-link :to="{ path: '/contact' }" data-cursor-hover data-cursor-mix-blend-mode="difference">Contact</router-link></li>
      </ul>
    </div>
    <cursor-fx color="#56320e" color-hover="#56320e" />
  </nav>
</template>

<script>
import $ from 'jquery'
import { CursorFx } from '@luxdamore/vue-cursor-fx'
import '@luxdamore/vue-cursor-fx/dist/CursorFx.css'

export default {
  name: 'Nav',
  components: {
    CursorFx
  },
  methods: {
  },
  mounted () {
    $('.hamburger').click(function () {
      if (!$('.hamburger').hasClass('is-active')) {
        $('.hamburger').addClass('is-active')
        $('.menu-block').addClass('menu-visible')
      } else {
        $('.menu-block').addClass('menu-invisible')
        setTimeout(function () {
          $('.hamburger').removeClass('is-active')
          $('.menu-block').removeClass('menu-visible')
          $('.menu-block').removeClass('menu-invisible')
        }, 0)
      }
    })
    $('nav ul li a').click(function () {
      $('.menu-block').addClass('menu-invisible')
      setTimeout(function () {
        $('.hamburger').removeClass('is-active')
        $('.menu-block').removeClass('menu-visible')
        $('.menu-block').removeClass('menu-invisible')
      }, 1600)
    })
    $('.logo, .startProject').click(function () {
      if ($('.hamburger').hasClass('is-active')) {
        $('.menu-block').addClass('menu-invisible')
        setTimeout(function () {
          $('.hamburger').removeClass('is-active')
          $('.menu-block').removeClass('menu-visible')
          $('.menu-block').removeClass('menu-invisible')
        }, 0)
      }
    })
  }
}
</script>

<style lang='scss'>
.cursor-fx{
  position:relative;
  z-index:99999;
  mix-blend-mode: difference;
  &__inner__inside{
    background-color:#56320e !important;
    border:0px !important;
  }
  &__inner__outside{
    background:#ceffc1 !important;
    border:0px !important;
  }
  &--hover{
    .cursor-fx__inner__inside{
      background-color:#56320e !important;
    }
    .cursor-fx__inner__outside{
      background:#ceffc1 !important;
    } 
  }
}

.menu-block {
  background-color: #70c0a3;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: all .5s ease;
  &.menu-visible {
    background-color: #70c0a3;
    opacity: 1;
    visibility: visible;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-delay: .5s;
    animation-name: changeColor;
    &.menu-invisible {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: 2.5s;
      animation-name: revChangeColor;
    }
  }
}
@-webkit-keyframes changeColor {
  0% {
    background-color: #70c0a3;
  }
  100% {
    background-color: #f4eeb4;
  }
}
@keyframes changeColor {
  0% {
    background-color: #70c0a3;
  }
  100% {
    background-color: #f4eeb4;
  }
}
@-webkit-keyframes revChangeColor {
  0% {
    background-color: #f4eeb4;
  }
  100% {
    background-color: #70c0a3;
  }
}
@keyframes revChangeColor {
  0% {
    background-color: #f4eeb4;
  }
  100% {
    background-color: #70c0a3;
  }
}
.menu-block-wrapper {
  margin-top: 8%;
}
.menu-block {
  ul li {
    opacity: 0;
    transform: translateY(20px) skew(0deg, -25deg) translate(0, -96%);
    overflow: hidden;
    &:nth-child(1) {
      margin-left: -75%;
    }
  }
  &.menu-visible {
    ul li:nth-child(1) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: .35s;
      animation-name: menuVisible;
    }
    &.menu-invisible ul li:nth-child(1) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: 1s;
      animation-name: menuInvisible;
    }
  }
  ul li:nth-child(2) {
    margin-left: -25%;
  }
  &.menu-visible {
    ul li:nth-child(2) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: .70s;
      animation-name: menuVisible;
    }
    &.menu-invisible ul li:nth-child(2) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: .75s;
      animation-name: menuInvisible;
    }
  }
  ul li:nth-child(3) {
    margin-left: 25%;
  }
  &.menu-visible {
    ul li:nth-child(3) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: 1.05s;
      animation-name: menuVisible;
    }
    &.menu-invisible ul li:nth-child(3) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: .5s;
      animation-name: menuInvisible;
    }
  }
  ul li:nth-child(4) {
    margin-left: 75%;
  }
  &.menu-visible {
    ul li:nth-child(4) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: 1.4s;
      animation-name: menuVisible;
    }
    &.menu-invisible ul li:nth-child(4) {
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-delay: .25s;
      animation-name: menuInvisible;
    }
  }
  ul li a {
    font-family: 'DeValencia-Regular';
    font-size: 100px;
    color: #425454;
    text-transform: uppercase;
    letter-spacing: -33px;
    display: inline-block;
    padding-right: 25px;
    position: relative;
    &:after {
      position: absolute;
      left: 0;
      top: 0;
      width: 0%;
      height: 100%;
      background-color: rgba(217, 91, 78, 0.9);
      z-index: -1;
    }
    &:hover {
      color: #f4eeb4;
      &:after {
        width: 100%;
      }
    }
  }
}
@-webkit-keyframes menuVisible {
  0% {
    opacity: 0;
    width: 0;
  }
  100% {
    opacity: 1;
    width: 100%;
  }
}
@keyframes menuVisible {
  0% {
    opacity: 0;
    width: 0;
  }
  100% {
    opacity: 1;
    width: 100%;
  }
}
@-webkit-keyframes menuInvisible {
  0% {
    opacity: 1;
    width: 100%;
  }
  100% {
    opacity: 1;
    width: 0;
  }
}
@keyframes menuInvisible {
  0% {
    opacity: 1;
    width: 100%;
  }
  100% {
    opacity: 1;
    width: 0;
  }
}
@media screen and (max-width: 1080px) {
  .menu-block {
    padding: 50px 0 0 50px;
    ul li a {
      font-size: 80px;
      letter-spacing: -25px;
      padding-right: 20px;
    }
  }
}
@media screen and (max-width: 776px) {
  .menu-block {
    padding: 0 0 0 50px;
    ul li a {
      font-size: 60px;
      letter-spacing: -20px;
    }
  }
}
</style>
